export default __webpack_public_path__ + "static/media/boy.d3c49225.png";